import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  nav: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    padding: "0 0 4px"
  },
  navButton: {
    color: "#e2e8f0 !important",
    border: "1px solid #404754 !important",
    backgroundColor: "#2c3139 !important",
    width: "40px !important",
    height: "40px !important"
  },
  navLabel: {
    fontSize: 14,
    color: "#94a3b8",
    minWidth: 80,
    textAlign: "center"
  }
});

const CardNav = ({
  cardPosition,
  totalCards,
  onPrevious,
  onNext,
  canGoPrevious,
  canGoNext
}: {
  cardPosition: number;
  totalCards: number;
  onPrevious: () => void;
  onNext: () => void;
  canGoPrevious: boolean;
  canGoNext: boolean;
}) => {
  const classes = useStyles();

  return (
    <nav className={classes.nav} aria-label="Card navigation">
      <IconButton
        aria-label="Previous card"
        className={classes.navButton}
        disabled={!canGoPrevious}
        onClick={onPrevious}>
        <ChevronLeftIcon />
      </IconButton>
      <span className={classes.navLabel}>
        {totalCards > 0 ? `${cardPosition} of ${totalCards}` : "—"}
      </span>
      <IconButton
        aria-label="Next card"
        className={classes.navButton}
        disabled={!canGoNext}
        onClick={onNext}>
        <ChevronRightIcon />
      </IconButton>
    </nav>
  );
};

export default CardNav;
